import { observable, action } from 'mobx';
import { upgradeStore } from './upgrade';
import Upgrade from '../../pages/view/modules/Upgrade';
import UpgradeCpu2 from '../../pages/view/modules/UpgradeCpu2';
import UpgradeNBFW from '../../pages/view/modules/UpgradeNBFW';
import { readStore } from './rf';
import Reboot from '../../pages/view/modules/Reboot';
import Reset from '../../pages/view/modules/Reset';
import TestModule from '../../pages/view/modules/TestModule';
import InitModule from '../../pages/view/modules/InitModule';
import RebootByRFID from '../../pages/view/modules/RebootByRFID';
import RebootByRFIDWrite from '../../pages/view/modules/RebootByRFIDWrite';
import ResetByRFID from '../../pages/view/modules/ResetByRFID';
import ResetByRFIDWrite from '../../pages/view/modules/ResetByRFIDWrite';
import Live from '../../pages/view/modules/Live';
import { geoStore } from './geo';
import Fix from '../../pages/view/modules/Fix';
import FixForce from '../../pages/view/modules/FixForce';
import { fixStore } from './fix';
import { recoverStore } from './recover';
import GotoMode from '../../pages/view/modules/GotoMode';
import FixSecond from '../../pages/view/modules/FixSecond';
import AlterIP from '../../pages/view/modules/AlterIP';
import ReadPart from '../../pages/view/modules/ReadPart';
import ClearPart from '../../pages/view/modules/ClearPart';
import Recover from '../../pages/view/modules/Recover';
import SwitchChannel from '../../pages/view/modules/SwitchChannel';
import ReadWorkMode from '../../pages/view/modules/ReadWorkMode';
import DetectSpeed from '../../pages/view/modules/DetectSpeed';
import BtbOn from '../../pages/view/modules/BtbOn';
import BtbOff from '../../pages/view/modules/BtbOff';
import QuitShutdown from '../../pages/view/modules/QuitShutdown';
import SyncTime from '../../pages/view/modules/SyncTime';
import AutoSyncTime from '../../pages/view/modules/AutoSyncTime';

export default class NormalDebugStore {
  @observable blePanels = [
    {
      title: '升级cpu1',
      status: 'default',
      defaultText: '升级',
      PanelComponent: Upgrade,
      store: upgradeStore,
      readStore,
      show: true,
      visible: false,
    },
    {
      title: '升级cpu2',
      status: 'default',
      defaultText: '升级',
      PanelComponent: UpgradeCpu2,
      store: upgradeStore,
      readStore,
      show: true,
      visible: false,
    },
    {
      title: '升级NB模组',
      status: 'default',
      defaultText: '升级',
      PanelComponent: UpgradeNBFW,
      store: upgradeStore,
      show: function isShow() {
        return readStore.isNB();
      },
      readStore,
      visible: false,
    },
    {
      title: '重启',
      status: 'default',
      defaultText: '重启',
      PanelComponent: Reboot,
      show: true,
      visible: false,
    },
    {
      title: '重置',
      status: 'default',
      defaultText: '重置',
      PanelComponent: Reset,
      show: true,
      visible: false,
    },
    {
      title: '测试',
      status: 'default',
      defaultText: '测试组件',
      PanelComponent: TestModule,
      show: true,
      visible: false,
    },
    {
      title: '初始化',
      status: 'default',
      defaultText: '初始化',
      PanelComponent: InitModule,
      show: true,
      visible: false,
    },
    {
      title: '切换模式',
      status: 'default',
      defaultText: '切换模式',
      PanelComponent: GotoMode,
      show: true,
      visible: false,
    },
    {
      title: '实时检测',
      status: 'default',
      defaultText: 'live',
      PanelComponent: Live,
      store: geoStore,
      show: true,
      visible: false,
    },
    {
      title: '修复分区',
      status: 'default',
      defaultText: 'fix',
      PanelComponent: Fix,
      store: fixStore,
      show: true,
      visible: false,
    },
    {
      title: '强制修复',
      status: 'default',
      defaultText: 'fix',
      PanelComponent: FixForce,
      store: fixStore,
      show: true,
      visible: false,
    },
    {
      title: '修复第二步',
      status: 'default',
      defaultText: 'fix',
      PanelComponent: FixSecond,
      store: fixStore,
      show: true,
      visible: false,
    },
    {
      title: '修改IP',
      status: 'default',
      defaultText: '修改IP',
      PanelComponent: AlterIP,
      show: true,
      visible: false,
    },
    {
      title: '恢复出厂设置',
      status: 'default',
      defaultText: 'recover',
      PanelComponent: Recover,
      show: true,
      store: recoverStore,
      visible: false,
    },
    {
      title: '切换信道',
      status: 'default',
      defaultText: '切换信道',
      PanelComponent: SwitchChannel,
      show: true,
      visible: false,
    },
    {
      title: '修改检测速度',
      status: 'default',
      defaultText: 'alter',
      PanelComponent: DetectSpeed,
      show: true,
      visible: false,
    },
    {
      title: '退出保护模式',
      status: 'default',
      defaultText: '退出保护模式',
      PanelComponent: QuitShutdown,
      show: true,
      visible: false,
    },
    {
      title: '服务器时间校准',
      status: 'default',
      defaultText: '服务器时间校准',
      PanelComponent: SyncTime,
      show: true,
      visible: false,
    },
    {
      title: '模组时间自动校准',
      status: 'default',
      defaultText: '模组时间自动校准',
      PanelComponent: AutoSyncTime,
      show: true,
      visible: false,
    },
  ];

  @observable rfPanels = [
    {
      title: '重启',
      status: 'default',
      defaultText: '重启',
      PanelComponent: RebootByRFID,
      show: true,
      visible: false,
    },
    {
      title: '重置',
      status: 'default',
      defaultText: '重置',
      PanelComponent: ResetByRFID,
      show: true,
      visible: false,
    },
  ];

  @observable rfWritePanels = [
    {
      title: '重启',
      status: 'default',
      defaultText: '重启',
      PanelComponent: RebootByRFIDWrite,
      show: true,
      visible: false,
    },
    {
      title: '重置',
      status: 'default',
      defaultText: '重置',
      PanelComponent: ResetByRFIDWrite,
      show: true,
      visible: false,
    },
    {
      title: '读分区',
      status: 'default',
      defaultText: '读分区',
      PanelComponent: ReadPart,
      show: true,
      visible: false,
    },
    {
      title: '地磁模式',
      status: 'default',
      defaultText: '读模式',
      PanelComponent: ReadWorkMode,
      show: true,
      store: readStore,
      visible: false,
    },
    {
      title: '清空命令区',
      status: 'default',
      defaultText: 'clear',
      PanelComponent: ClearPart,
      show: true,
      store: readStore,
      visible: false,
    },
    {
      title: '开启蓝牙广播',
      status: 'default',
      defaultText: 'btb on',
      PanelComponent: BtbOn,
      show: true,
      visible: false,
    },
    {
      title: '关闭蓝牙广播',
      status: 'default',
      defaultText: 'btb off',
      PanelComponent: BtbOff,
      show: true,
      visible: false,
      bodyStyle: { display: 'none' },
    },
  ];

  @action showBlePanel(index) {
    this.blePanels[index].visible = true;
  }

  @action showRfPanel(index) {
    this.rfPanels[index].visible = true;
  }

  @action showRfWritePanel(index) {
    this.rfWritePanels[index].visible = true;
  }
}

export const normalDebugStore = new NormalDebugStore();
